import React from 'react'
import { Link } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import Icon from '../../shared/Icon/Icon'
import { createNavigationUrl } from '../../helpers/createNavigationUrl'
import useAllSitePage from '../../hooks/useAllSitePage'
import './BannerList.scss'

const BannerList = ({ data }) => {    
  const pagesPath = useAllSitePage()
  const { 
    allSitePage: matchPages 
  } = pagesPath

  const addLink = (item) => {
    if (
      item.p_ucc_page ||
      item.p_ucc_microsite ||
      item.p_ucc_career ||
      item.url
    ) {
      return (
        <Link to={createNavigationUrl(matchPages.nodes, item)}>
          <h4>{item.title}</h4>
          <p>{item.description}</p>
        </Link>
      )
    } else {
      return (
        <>
          <h4>{item.title}</h4>

          {item.description &&
            <ReactMarkdown
              renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
              rehypePlugins={false}
              children={item.description}
              className="format-markdown-container fade-in-image mt-0"
            />
          }
        </>
      )
    }
  }

  const cards = data?.Card.map((item) => {
    return (
      <div 
        key={'bannerCard-' + item.id} 
        id={'bannerCard-' + item.id}
        className="card_item d-flex mb-4" 
      >
        {item.image ? (
          <div className="card_item_logo">
            <img className="d-block" src={item.image?.url} placeholder="blurred" alt={item.title}/>
          </div>
        ) : (
          <div className="card_item_logo">
            <Icon iconSize="fa-2x" {...item.icon} />
          </div>
        )}
        <div className="col-9 pe-2">{addLink(item)}</div>
      </div>
    )
  })

  return (
    <div 
      id={'bannerList-' + data.id}
      className="container my-5" 
    >
      <div className="bannerList d-md-flex flex-row">
        <h1 className="bannerList__title col-md-6 col-xl-6 align-self-center mb-4">
          {data?.title}
        </h1>
        <div className="col-md-6 col-xl-6">{cards}</div>
      </div>
    </div>
  )
}

export default BannerList